// extracted by mini-css-extract-plugin
export default {"iconBox":"Notification_iconBox__1jtGG","new":"Notification_new__nEzjE","pulse":"Notification_pulse__CcODm","notification":"Notification_notification__-a2GG"};